import { HabitSchedule, Timestamp } from '@griply/types';
import { getActiveSchedule } from '@griply/utils';
import { useMemo } from 'react';

export const useActiveSchedule = (
  schedules: HabitSchedule[] | undefined | null,
  today: Timestamp,
) => useMemo(() => getActiveSchedule(schedules, today), [schedules, today]);
